import { useState } from 'react';
import { TableInput } from '../../../../components/common';
import { ModuleDataHandler } from '../../helpers/handleReportCalc';

interface IProps {
  moduleData: any;
  isView: boolean;
  item: any;
  index: number;
}
const TBodyRow = ({ moduleData, isView, item, index }: IProps) => {
  const [render, setRender] = useState(false);
  const dataHandler = new ModuleDataHandler(moduleData);

  return (
    <>
      <tr>
        <td>
          {item?.customer_name ||
            (typeof item?.part_id !== 'string' &&
              item?.part_id?.customer_id.customer_name)}
        </td>
        <td>
          {item?.part_number ||
            (typeof item?.part_id !== 'string' && item?.part_id?.part_number)}
        </td>
        <td>
          {item?.part_name ||
            (typeof item?.part_id !== 'string' && item?.part_id?.part_name)}
        </td>
        <td>{item?.rm_grade}</td>
        <td>
          {item?.sale_rate ||
            (typeof item?.part_id !== 'string' && item?.part_id?.sale_rate)}
        </td>
        <td>{item?.rm_thick}</td>
        <td>{item?.rm_width}</td>
        <td>{item?.rm_length}</td>
        <td>{item?.rm_strip_wt}</td>
        <td>{item?.rm_no_of_pc}</td>
        <td>{item?.rm_gross_wt}</td>

        {item?.rm_days_arr?.map((day: any, dayIdx: number) => (
          <td>
            <TableInput
              isView={isView}
              type="number"
              value={item.rm_days_arr[dayIdx] || null}
              onChange={(e) => {
                item.rm_days_arr[dayIdx] = Number(e.target.value);
                dataHandler.handelRmInputWeightAndQty(index);
                setRender((prev) => !prev);
              }}
            />
          </td>
        ))}
        <td>{item.rm_input_weight}</td>
        <td>{item.rm_input_qty}</td>
      </tr>
    </>
  );
};

export default TBodyRow;
